import { render, staticRenderFns } from "./ResultsSummaryHistory.vue?vue&type=template&id=a97d92a6&scoped=true"
import script from "./ResultsSummaryHistory.vue?vue&type=script&lang=js"
export * from "./ResultsSummaryHistory.vue?vue&type=script&lang=js"
import style0 from "./ResultsSummaryHistory.vue?vue&type=style&index=0&id=a97d92a6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97d92a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a97d92a6')) {
      api.createRecord('a97d92a6', component.options)
    } else {
      api.reload('a97d92a6', component.options)
    }
    module.hot.accept("./ResultsSummaryHistory.vue?vue&type=template&id=a97d92a6&scoped=true", function () {
      api.rerender('a97d92a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/ResultsSummaryHistory.vue"
export default component.exports